import { Link, Outlet } from 'react-router-dom';

export function LandingLayout() {
  return (
    <div className="min-h-dvh flex flex-col bg-[color:var(--color-cream-100)]">
      <header className="sticky top-0 z-40 border-b border-[color:var(--color-border)] bg-[color:var(--color-cream-100)]/85 backdrop-blur">
        <nav className="mx-auto flex h-16 max-w-6xl items-center justify-between px-6">
          <Link to="/" className="font-serif text-xl font-semibold">
            Lashpic
          </Link>
          <div className="flex items-center gap-5 text-sm">
            <a href="/#features" className="hover:text-[color:var(--color-lavender-600)]">
              기능
            </a>
            <Link to="/pricing" className="hover:text-[color:var(--color-lavender-600)]">
              가격
            </Link>
            <Link to="/faq" className="hidden hover:text-[color:var(--color-lavender-600)] sm:inline">
              자주 묻는 질문
            </Link>
            <Link
              to="/app/login"
              className="rounded-full bg-[color:var(--color-lavender-500)] px-4 py-1.5 text-white"
            >
              시작하기
            </Link>
          </div>
        </nav>
      </header>

      <main className="flex-1">
        <Outlet />
      </main>

      <footer className="mt-24 border-t border-[color:var(--color-border)] bg-white/40 py-10 text-sm text-[color:var(--color-muted-foreground)]">
        <div className="mx-auto flex max-w-6xl flex-col gap-3 px-6 md:flex-row md:items-center md:justify-between">
          <div>© 2026 Lashpic — 한국 속눈썹 연장샵을 위한 AI 스튜디오</div>
          <div className="flex gap-4">
            <Link to="/terms">이용약관</Link>
            <Link to="/privacy">개인정보처리방침</Link>
            <Link to="/faq">FAQ</Link>
          </div>
        </div>
      </footer>
    </div>
  );
}
